// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__32j2_","content":"styles_content__3wrdW"};